import { useMutation, useQueryCache } from "react-query";
import { useToasts } from "react-toast-notifications";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import {
  deleteNotifySubscriberContactMethodSubscriptionPreferences,
  DeleteNotifySubscriberContactMethodSubscriptionPreferencesResponse,
} from "../../../queries/notify";
import { buildNotifyInfiniteSubscriberContactMethodsQueryKey } from "./useInfiniteNotifySubscriberContactMethods";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";
import { ToastStatuses } from "../../../components/global_components/Toast";

export function useNotifySubscriberContactMethodRemoveFromGroup({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: (
    subscriberContractMethod: DeleteNotifySubscriberContactMethodSubscriptionPreferencesResponse,
  ) => void | Promise<void>;
  onError?: () => void;
} = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [
    deleteNotifySubscriptionPreferencesMutation,
    { isLoading: isDeleteNotifySubscriberContactMethodSubscriptionPreferencesLoading },
  ] = useMutation(deleteNotifySubscriberContactMethodSubscriptionPreferences(networkHeaders), {
    onSuccess: async (data) => {
      await queryCache.invalidateQueries(buildNotifyInfiniteSubscriberContactMethodsQueryKey());
      await queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
      onSuccess(data);
    },
    onError: () => {
      addToast("Failed to remove contact method from group", { appearance: ToastStatuses.Error, autoDismiss: true });
      onError();
    },
  });

  const removeSubscriberContactMethodFromGroup = async (id: number, subscriptionGroupId: number) => {
    return await deleteNotifySubscriptionPreferencesMutation({ id, body: { subscriptionGroupId } });
  };

  return {
    removeSubscriberContactMethodFromGroup,
    isDeleteNotifySubscriberContactMethodSubscriptionPreferencesLoading,
  };
}
